import React, { PropTypes } from 'react';
import classnames from 'classnames';

const Author = ({ image, content_html, title, className, background }) => (
  <section className={classnames('block block-author', className, background)}>
    <div className="row align-center">
      <div className="columns large-4 image-container">
        <img className="avatar avatar-xl avatar-round avatar-team" src={image.url} alt={image.alt}/>
      </div>
      <div className="columns small-16 large-8">
        <h3>{title}</h3>
        <div dangerouslySetInnerHTML={{ __html: content_html }} />
      </div>
    </div>
  </section>
);

Author.propTypes = {
  image: PropTypes.object,
  content_html: PropTypes.string,
  className: PropTypes.string,
  background: PropTypes.string
};

export default Author;



// WEBPACK FOOTER //
// ./landing_pages/components/author.jsx